// AUTO-GENERATED by scripts/gen-i18n-resources.js — DO NOT EDIT BY HAND.
// Run `yarn i18n:gen` after adding or changing locale JSON files.
import en_automated from './locales/en/automated.json';
import en_betaLabelling from './locales/en/betaLabelling.json';
import en_cards from './locales/en/cards.json';
import en_catalog from './locales/en/catalog.json';
import en_catalogChecker from './locales/en/catalogChecker.json';
import en_catalogDashboard from './locales/en/catalogDashboard.json';
import en_catalogDuplicates from './locales/en/catalogDuplicates.json';
import en_common from './locales/en/common.json';
import en_customComponents from './locales/en/customComponents.json';
import en_dashboard from './locales/en/dashboard.json';
import en_grading from './locales/en/grading.json';
import en_labelDesigns from './locales/en/labelDesigns.json';
import en_labelGenerator from './locales/en/labelGenerator.json';
import en_labelling from './locales/en/labelling.json';
import en_marketing from './locales/en/marketing.json';
import en_misc from './locales/en/misc.json';
import en_mystery from './locales/en/mystery.json';
import en_navigation from './locales/en/navigation.json';
import en_order from './locales/en/order.json';
import en_overdueOrders from './locales/en/overdueOrders.json';
import en_pagesMisc from './locales/en/pagesMisc.json';
import en_partners from './locales/en/partners.json';
import en_shopify from './locales/en/shopify.json';
import en_ui from './locales/en/ui.json';
import en_user from './locales/en/user.json';
import en_workflow from './locales/en/workflow.json';
import ja_automated from './locales/ja/automated.json';
import ja_betaLabelling from './locales/ja/betaLabelling.json';
import ja_cards from './locales/ja/cards.json';
import ja_catalog from './locales/ja/catalog.json';
import ja_catalogChecker from './locales/ja/catalogChecker.json';
import ja_catalogDashboard from './locales/ja/catalogDashboard.json';
import ja_catalogDuplicates from './locales/ja/catalogDuplicates.json';
import ja_common from './locales/ja/common.json';
import ja_customComponents from './locales/ja/customComponents.json';
import ja_dashboard from './locales/ja/dashboard.json';
import ja_grading from './locales/ja/grading.json';
import ja_labelDesigns from './locales/ja/labelDesigns.json';
import ja_labelGenerator from './locales/ja/labelGenerator.json';
import ja_labelling from './locales/ja/labelling.json';
import ja_marketing from './locales/ja/marketing.json';
import ja_misc from './locales/ja/misc.json';
import ja_mystery from './locales/ja/mystery.json';
import ja_navigation from './locales/ja/navigation.json';
import ja_order from './locales/ja/order.json';
import ja_overdueOrders from './locales/ja/overdueOrders.json';
import ja_pagesMisc from './locales/ja/pagesMisc.json';
import ja_partners from './locales/ja/partners.json';
import ja_shopify from './locales/ja/shopify.json';
import ja_ui from './locales/ja/ui.json';
import ja_user from './locales/ja/user.json';
import ja_workflow from './locales/ja/workflow.json';
import de_automated from './locales/de/automated.json';
import de_betaLabelling from './locales/de/betaLabelling.json';
import de_cards from './locales/de/cards.json';
import de_catalog from './locales/de/catalog.json';
import de_catalogChecker from './locales/de/catalogChecker.json';
import de_catalogDashboard from './locales/de/catalogDashboard.json';
import de_catalogDuplicates from './locales/de/catalogDuplicates.json';
import de_common from './locales/de/common.json';
import de_customComponents from './locales/de/customComponents.json';
import de_dashboard from './locales/de/dashboard.json';
import de_grading from './locales/de/grading.json';
import de_labelDesigns from './locales/de/labelDesigns.json';
import de_labelGenerator from './locales/de/labelGenerator.json';
import de_labelling from './locales/de/labelling.json';
import de_marketing from './locales/de/marketing.json';
import de_misc from './locales/de/misc.json';
import de_mystery from './locales/de/mystery.json';
import de_navigation from './locales/de/navigation.json';
import de_order from './locales/de/order.json';
import de_overdueOrders from './locales/de/overdueOrders.json';
import de_pagesMisc from './locales/de/pagesMisc.json';
import de_partners from './locales/de/partners.json';
import de_shopify from './locales/de/shopify.json';
import de_ui from './locales/de/ui.json';
import de_user from './locales/de/user.json';
import de_workflow from './locales/de/workflow.json';

export const resources = {
  en: {
    'automated': en_automated,
    'betaLabelling': en_betaLabelling,
    'cards': en_cards,
    'catalog': en_catalog,
    'catalogChecker': en_catalogChecker,
    'catalogDashboard': en_catalogDashboard,
    'catalogDuplicates': en_catalogDuplicates,
    'common': en_common,
    'customComponents': en_customComponents,
    'dashboard': en_dashboard,
    'grading': en_grading,
    'labelDesigns': en_labelDesigns,
    'labelGenerator': en_labelGenerator,
    'labelling': en_labelling,
    'marketing': en_marketing,
    'misc': en_misc,
    'mystery': en_mystery,
    'navigation': en_navigation,
    'order': en_order,
    'overdueOrders': en_overdueOrders,
    'pagesMisc': en_pagesMisc,
    'partners': en_partners,
    'shopify': en_shopify,
    'ui': en_ui,
    'user': en_user,
    'workflow': en_workflow,
  },
  ja: {
    'automated': ja_automated,
    'betaLabelling': ja_betaLabelling,
    'cards': ja_cards,
    'catalog': ja_catalog,
    'catalogChecker': ja_catalogChecker,
    'catalogDashboard': ja_catalogDashboard,
    'catalogDuplicates': ja_catalogDuplicates,
    'common': ja_common,
    'customComponents': ja_customComponents,
    'dashboard': ja_dashboard,
    'grading': ja_grading,
    'labelDesigns': ja_labelDesigns,
    'labelGenerator': ja_labelGenerator,
    'labelling': ja_labelling,
    'marketing': ja_marketing,
    'misc': ja_misc,
    'mystery': ja_mystery,
    'navigation': ja_navigation,
    'order': ja_order,
    'overdueOrders': ja_overdueOrders,
    'pagesMisc': ja_pagesMisc,
    'partners': ja_partners,
    'shopify': ja_shopify,
    'ui': ja_ui,
    'user': ja_user,
    'workflow': ja_workflow,
  },
  de: {
    'automated': de_automated,
    'betaLabelling': de_betaLabelling,
    'cards': de_cards,
    'catalog': de_catalog,
    'catalogChecker': de_catalogChecker,
    'catalogDashboard': de_catalogDashboard,
    'catalogDuplicates': de_catalogDuplicates,
    'common': de_common,
    'customComponents': de_customComponents,
    'dashboard': de_dashboard,
    'grading': de_grading,
    'labelDesigns': de_labelDesigns,
    'labelGenerator': de_labelGenerator,
    'labelling': de_labelling,
    'marketing': de_marketing,
    'misc': de_misc,
    'mystery': de_mystery,
    'navigation': de_navigation,
    'order': de_order,
    'overdueOrders': de_overdueOrders,
    'pagesMisc': de_pagesMisc,
    'partners': de_partners,
    'shopify': de_shopify,
    'ui': de_ui,
    'user': de_user,
    'workflow': de_workflow,
  },
} as const;

export const namespaces = ['automated', 'betaLabelling', 'cards', 'catalog', 'catalogChecker', 'catalogDashboard', 'catalogDuplicates', 'common', 'customComponents', 'dashboard', 'grading', 'labelDesigns', 'labelGenerator', 'labelling', 'marketing', 'misc', 'mystery', 'navigation', 'order', 'overdueOrders', 'pagesMisc', 'partners', 'shopify', 'ui', 'user', 'workflow'] as const;
export const defaultNS = 'common';
